
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser'
export { Prisma }
export * as $Enums from './enums'
export * from './enums';
/**
 * Model Account
 * NextAuth accounts (OAuth/email providers). Auth metadata for a user.
 */
export type Account = Prisma.AccountModel
/**
 * Model Session
 * NextAuth sessions.
 */
export type Session = Prisma.SessionModel
/**
 * Model User
 * Application users (auth + billing metadata).
 */
export type User = Prisma.UserModel
/**
 * Model ReviewerCredential
 * Password credential for the dedicated, time-limited reviewer account.
 * The password is stored only as a one-way hash; normal users never use this
 * provider and continue to authenticate through Google or email magic links.
 */
export type ReviewerCredential = Prisma.ReviewerCredentialModel
/**
 * Model ReviewerAccountAudit
 * Immutable operational audit trail for reviewer-account changes made by the
 * CLI. Secrets and password material are intentionally never stored here.
 */
export type ReviewerAccountAudit = Prisma.ReviewerAccountAuditModel
/**
 * Model UserEntitlementGrant
 * Auditable, optionally expiring product entitlement granted outside Stripe.
 */
export type UserEntitlementGrant = Prisma.UserEntitlementGrantModel
/**
 * Model CourseTopicCompletion
 * Presence of a row means that a user explicitly completed a theory topic.
 * Course definitions remain versioned in the repository; this table stores
 * only the user's progress against stable content identifiers.
 */
export type CourseTopicCompletion = Prisma.CourseTopicCompletionModel
/**
 * Model CourseModuleAccess
 * Last time a user opened a module. Course structure remains in content files.
 * The last track is context only; completion is shared by topic ID.
 */
export type CourseModuleAccess = Prisma.CourseModuleAccessModel
/**
 * Model CourseTrackFollow
 * Explicitly followed learning tracks. Progress remains derived from course topics.
 */
export type CourseTrackFollow = Prisma.CourseTrackFollowModel
/**
 * Model CourseExerciseAttempt
 * Immutable result of one submitted objective exercise attempt.
 * Course content remains versioned in the repository; JSON stores only the
 * student's answers and the evaluated result for this attempt.
 */
export type CourseExerciseAttempt = Prisma.CourseExerciseAttemptModel
/**
 * Model StripeSubscription
 * Local, historical projection of Stripe subscriptions. Stripe remains the financial source of truth.
 */
export type StripeSubscription = Prisma.StripeSubscriptionModel
/**
 * Model StripeEvent
 * Minimal webhook audit record; payloads and PII are intentionally not retained.
 */
export type StripeEvent = Prisma.StripeEventModel
/**
 * Model FiscalTransaction
 * Minimal, durable fiscal outbox action; raw provider payloads and PII are not retained.
 */
export type FiscalTransaction = Prisma.FiscalTransactionModel
/**
 * Model StripeCheckoutReservation
 * Durable, expiring reservation preventing concurrent Checkout creation per user.
 */
export type StripeCheckoutReservation = Prisma.StripeCheckoutReservationModel
/**
 * Model FiscalTaxIdLock
 * Short-lived cross-pod lease used while reconciling a Stripe Customer Tax ID.
 */
export type FiscalTaxIdLock = Prisma.FiscalTaxIdLockModel
/**
 * Model CreditAccount
 * Current non-expired balances for a user.
 */
export type CreditAccount = Prisma.CreditAccountModel
/**
 * Model CreditPurchase
 * One immutable Stripe Checkout purchase of AI credits.
 */
export type CreditPurchase = Prisma.CreditPurchaseModel
/**
 * Model CreditLedgerEntry
 * Append-only audit trail for credit grants and consumption.
 */
export type CreditLedgerEntry = Prisma.CreditLedgerEntryModel
/**
 * Model AiUsageRecord
 * Provider usage and the corresponding ledger charge.
 */
export type AiUsageRecord = Prisma.AiUsageRecordModel
/**
 * Model AiReportDefinition
 * User-owned definition for a recurring AI-generated report.
 */
export type AiReportDefinition = Prisma.AiReportDefinitionModel
/**
 * Model AiReportRun
 * Durable result of one scheduled AI report occurrence, retained for 30 days.
 */
export type AiReportRun = Prisma.AiReportRunModel
/**
 * Model ContactSubmission
 * Message submitted through the public contact form.
 */
export type ContactSubmission = Prisma.ContactSubmissionModel
/**
 * Model UserAiSettings
 * User-level AI preferences. Created only when the user saves a preference.
 */
export type UserAiSettings = Prisma.UserAiSettingsModel
/**
 * Model ChatConversation
 * A user's persistent AI chat conversation.
 */
export type ChatConversation = Prisma.ChatConversationModel
/**
 * Model ChatMessage
 * An immutable user or assistant message in a chat conversation.
 */
export type ChatMessage = Prisma.ChatMessageModel
/**
 * Model VerificationToken
 * NextAuth email verification tokens.
 */
export type VerificationToken = Prisma.VerificationTokenModel
/**
 * Model FeatureFlags
 * Feature flags toggled at runtime.
 */
export type FeatureFlags = Prisma.FeatureFlagsModel
/**
 * Model FeatureFlagUser
 * Per-user access granted while a feature flag remains globally disabled.
 */
export type FeatureFlagUser = Prisma.FeatureFlagUserModel
/**
 * Model CatalogSavedSearch
 * Saved catalog searches owned by a specific user.
 */
export type CatalogSavedSearch = Prisma.CatalogSavedSearchModel
/**
 * Model UserPortfolio
 * User-owned investment portfolio. One user may maintain multiple portfolios.
 */
export type UserPortfolio = Prisma.UserPortfolioModel
/**
 * Model UserPortfolioTransaction
 * Normalized portfolio ledger. This is the source of truth for user-editable movements.
 */
export type UserPortfolioTransaction = Prisma.UserPortfolioTransactionModel
/**
 * Model UserPortfolioImportProvenance
 * Append-only baseline for one materialized B3 movement output. Import sessions
 * are replaceable upload state and must not be used for repair provenance.
 * The service exposes no update/delete operation. A database trigger rejects
 * UPDATE and direct DELETE; portfolio cascade deletion remains allowed. A
 * database owner/superuser can still disable triggers or bypass this policy.
 */
export type UserPortfolioImportProvenance = Prisma.UserPortfolioImportProvenanceModel
/**
 * Model UserPortfolioHoldingSnapshot
 * Cached current holdings derived from transactions for fast portfolio reads.
 */
export type UserPortfolioHoldingSnapshot = Prisma.UserPortfolioHoldingSnapshotModel
/**
 * Model UserPortfolioSummarySnapshot
 * Portfolio-level metrics materialized by the Python processor for direct UI reads.
 */
export type UserPortfolioSummarySnapshot = Prisma.UserPortfolioSummarySnapshotModel
/**
 * Model UserPortfolioExposureSnapshot
 * Current, dimension-scoped exposure view derived from priced portfolio holdings.
 */
export type UserPortfolioExposureSnapshot = Prisma.UserPortfolioExposureSnapshotModel
/**
 * Model UserPortfolioExposureSnapshotItem
 * Source-level explanation for a portfolio exposure snapshot value.
 */
export type UserPortfolioExposureSnapshotItem = Prisma.UserPortfolioExposureSnapshotItemModel
/**
 * Model UserPortfolioExposureSnapshotValue
 * One canonical exposure value materialized for a portfolio exposure snapshot.
 */
export type UserPortfolioExposureSnapshotValue = Prisma.UserPortfolioExposureSnapshotValueModel
/**
 * Model UserPortfolioPatrimonyHistory
 * Monthly historical market value of the supported portion of a portfolio.
 */
export type UserPortfolioPatrimonyHistory = Prisma.UserPortfolioPatrimonyHistoryModel
/**
 * Model UserPortfolioPatrimonyTypeHistory
 * Fund-type composition of one monthly portfolio patrimony point.
 */
export type UserPortfolioPatrimonyTypeHistory = Prisma.UserPortfolioPatrimonyTypeHistoryModel
/**
 * Model UserPortfolioPatrimonyCategoryHistory
 * Asset-category composition of one monthly portfolio patrimony point.
 */
export type UserPortfolioPatrimonyCategoryHistory = Prisma.UserPortfolioPatrimonyCategoryHistoryModel
/**
 * Model UserPortfolioPatrimonyAssetHistory
 * Per-asset market-value composition of one monthly portfolio patrimony point.
 */
export type UserPortfolioPatrimonyAssetHistory = Prisma.UserPortfolioPatrimonyAssetHistoryModel
/**
 * Model UserPortfolioInvestmentJournal
 * Explainable per-event portfolio balances used by the patrimony journal.
 * Financial values are expressed at ``eventDate`` purchasing power.
 */
export type UserPortfolioInvestmentJournal = Prisma.UserPortfolioInvestmentJournalModel
/**
 * Model UserPortfolioInvestmentJournalMonthly
 * Monthly valuation checkpoints from the same ledger as investment events.
 * They retain months without a movement for the patrimony chart.
 */
export type UserPortfolioInvestmentJournalMonthly = Prisma.UserPortfolioInvestmentJournalMonthlyModel
/**
 * Model UserPortfolioCapitalPreservationSnapshot
 * Monthly IPCA-based capital-preservation result for one requested window.
 */
export type UserPortfolioCapitalPreservationSnapshot = Prisma.UserPortfolioCapitalPreservationSnapshotModel
/**
 * Model UserPortfolioPositionHistory
 * Historical derived position state per portfolio/instrument/date after replaying the user ledger.
 */
export type UserPortfolioPositionHistory = Prisma.UserPortfolioPositionHistoryModel
/**
 * Model UserPortfolioIncomeHistory
 * Historical income timeline materialized for fast portfolio income and dividend screens.
 */
export type UserPortfolioIncomeHistory = Prisma.UserPortfolioIncomeHistoryModel
/**
 * Model UserPortfolioProcessingDiagnostic
 * Latest classified diagnostic produced by `user_snapshots` for a portfolio.
 * Always reflects the most-recent successful persist; preserves every raw
 * import row, the inferred synthetic operations and the legacy/zero-balance
 * assets the user should be able to inspect. See BACKLOG-018.
 */
export type UserPortfolioProcessingDiagnostic = Prisma.UserPortfolioProcessingDiagnosticModel
/**
 * Model UserPortfolioImportSession
 * Staging session for a portfolio import or creation before the portfolio is published.
 */
export type UserPortfolioImportSession = Prisma.UserPortfolioImportSessionModel
/**
 * Model UserPortfolioImportSessionItem
 * Raw rows parsed from a portfolio import session, preserving original structure only.
 */
export type UserPortfolioImportSessionItem = Prisma.UserPortfolioImportSessionItemModel
/**
 * Model InstrumentType
 * Async requests that create or reimport a portfolio and recalculate its views.
 * Fund type catalog. Populated by Fnet, Treasury Transparente and index sync.
 */
export type InstrumentType = Prisma.InstrumentTypeModel
/**
 * Model Instrument
 * Fnet instruments (primary instrument catalog). Populated by Fnet pipelines.
 */
export type Instrument = Prisma.InstrumentModel
/**
 * Model TreasuryQuote
 * Daily quotes published by Tesouro Transparente. The quote date is preserved
 * because this dataset describes daily offered rates and prices, not trades.
 */
export type TreasuryQuote = Prisma.TreasuryQuoteModel
/**
 * Model FixedIncomeCashFlowSchedule
 * Versioned future cash-flow schedule used by fixed-income pricing.
 * A schedule is tied to a reference date because indexed or projected flows
 * may change as new source information becomes available.
 */
export type FixedIncomeCashFlowSchedule = Prisma.FixedIncomeCashFlowScheduleModel
/**
 * Model FixedIncomeCashFlow
 * One normalized payment in a versioned fixed-income schedule.
 */
export type FixedIncomeCashFlow = Prisma.FixedIncomeCashFlowModel
/**
 * Model TreasuryFeeRule
 * Versioned B3 custody fee rule for Tesouro Direto titles (decision D13).
 * 
 * The base annual rate (0.20% a.a., pro rata die) is deterministic; the
 * charge model (collection timing) changed 2024-12-31 from semiannual
 * windows to event-based netting. A row with null `title_type` is the
 * default for all products; a product-specific row overrides it (used for
 * the Selic exemption threshold: amounts up to R$ 10,000 per CPF are
 * exempt, the rate applies to the excess only).
 */
export type TreasuryFeeRule = Prisma.TreasuryFeeRuleModel
/**
 * Model UserPortfolioExpense
 * One custody fee (expense) for a treasury title in a portfolio (D12).
 * 
 * Distinct from income and from transactions: a B3 "Cobrança de Taxa
 * Semestral" line is a real cash outflow that must not change quantity,
 * unit price, or market value of the holding.
 */
export type UserPortfolioExpense = Prisma.UserPortfolioExpenseModel
/**
 * Model FixedIncomeScreenerSnapshot
 * Derived fixed-income screening row for one instrument and quote date.
 * 
 * This is intentionally separate from the fund-oriented ScreenerSnapshot.
 * Quote fields are copied here so the read model can filter and sort without
 * joining product-specific derived data back through the legacy fund snapshot.
 */
export type FixedIncomeScreenerSnapshot = Prisma.FixedIncomeScreenerSnapshotModel
/**
 * Model InstrumentTradingIdentity
 * Latest trading identity observed in B3/COTAHIST for the instrument's listed code.
 */
export type InstrumentTradingIdentity = Prisma.InstrumentTradingIdentityModel
/**
 * Model InstrumentCnpj
 * Instrument <-> CNPJ relation (link Fnet to CVM). Updated by Fnet/CVM pipelines and processors.
 * Keep without FK because CVM registration data may not exist yet.
 */
export type InstrumentCnpj = Prisma.InstrumentCnpjModel
/**
 * Model CvmFund
 * CVM fund (RCVM 175) from registro_fundo.csv.
 */
export type CvmFund = Prisma.CvmFundModel
/**
 * Model CvmFundClass
 * CVM fund class (RCVM 175) from registro_classe.csv.
 */
export type CvmFundClass = Prisma.CvmFundClassModel
/**
 * Model CvmFundSubclass
 * CVM fund subclass (RCVM 175) from registro_subclasse.csv.
 */
export type CvmFundSubclass = Prisma.CvmFundSubclassModel
/**
 * Model CvmFiiInfMensalGeral
 * CVM FII informe mensal (geral) from inf_mensal_fii_geral.csv.
 */
export type CvmFiiInfMensalGeral = Prisma.CvmFiiInfMensalGeralModel
/**
 * Model CvmFiiInfMensalAtivoPassivo
 * CVM FII informe mensal (ativo/passivo) from inf_mensal_fii_ativo_passivo.csv.
 */
export type CvmFiiInfMensalAtivoPassivo = Prisma.CvmFiiInfMensalAtivoPassivoModel
/**
 * Model CvmFiiInfMensalComplemento
 * CVM FII informe mensal (complemento) from inf_mensal_fii_complemento.csv.
 */
export type CvmFiiInfMensalComplemento = Prisma.CvmFiiInfMensalComplementoModel
/**
 * Model CvmFiiInfTrimestralAlienacaoImovel
 * CVM FII informe trimestral (alienacao imovel) from inf_trimestral_fii_alienacao_imovel.csv.
 */
export type CvmFiiInfTrimestralAlienacaoImovel = Prisma.CvmFiiInfTrimestralAlienacaoImovelModel
/**
 * Model CvmFiiInfTrimestralAlienacaoTerreno
 * CVM FII informe trimestral (alienacao terreno) from inf_trimestral_fii_alienacao_terreno.csv.
 */
export type CvmFiiInfTrimestralAlienacaoTerreno = Prisma.CvmFiiInfTrimestralAlienacaoTerrenoModel
/**
 * Model CvmFiiInfTrimestralAquisicaoImovel
 * CVM FII informe trimestral (aquisicao imovel) from inf_trimestral_fii_aquisicao_imovel.csv.
 */
export type CvmFiiInfTrimestralAquisicaoImovel = Prisma.CvmFiiInfTrimestralAquisicaoImovelModel
/**
 * Model CvmFiiInfTrimestralAquisicaoTerreno
 * CVM FII informe trimestral (aquisicao terreno) from inf_trimestral_fii_aquisicao_terreno.csv.
 */
export type CvmFiiInfTrimestralAquisicaoTerreno = Prisma.CvmFiiInfTrimestralAquisicaoTerrenoModel
/**
 * Model CvmFiiInfTrimestralAtivo
 * CVM FII informe trimestral (ativo) from inf_trimestral_fii_ativo.csv.
 */
export type CvmFiiInfTrimestralAtivo = Prisma.CvmFiiInfTrimestralAtivoModel
/**
 * Model CvmFiiInfTrimestralAtivoGarantiaRentabilidade
 * CVM FII informe trimestral (ativo garantia rentabilidade) from inf_trimestral_fii_ativo_garantia_rentabilidade.csv.
 */
export type CvmFiiInfTrimestralAtivoGarantiaRentabilidade = Prisma.CvmFiiInfTrimestralAtivoGarantiaRentabilidadeModel
/**
 * Model CvmFiiInfTrimestralComplemento
 * CVM FII informe trimestral (complemento) from inf_trimestral_fii_complemento.csv.
 */
export type CvmFiiInfTrimestralComplemento = Prisma.CvmFiiInfTrimestralComplementoModel
/**
 * Model CvmFiiInfTrimestralDireito
 * CVM FII informe trimestral (direito) from inf_trimestral_fii_direito.csv.
 */
export type CvmFiiInfTrimestralDireito = Prisma.CvmFiiInfTrimestralDireitoModel
/**
 * Model CvmFiiInfTrimestralGeral
 * CVM FII informe trimestral (geral) from inf_trimestral_fii_geral.csv.
 */
export type CvmFiiInfTrimestralGeral = Prisma.CvmFiiInfTrimestralGeralModel
/**
 * Model CvmFiiInfTrimestralImovel
 * CVM FII informe trimestral (imovel) from inf_trimestral_fii_imovel.csv.
 */
export type CvmFiiInfTrimestralImovel = Prisma.CvmFiiInfTrimestralImovelModel
/**
 * Model CvmFiiInfTrimestralImovelDesempenho
 * CVM FII informe trimestral (imovel desempenho) from inf_trimestral_fii_imovel_desempenho.csv.
 */
export type CvmFiiInfTrimestralImovelDesempenho = Prisma.CvmFiiInfTrimestralImovelDesempenhoModel
/**
 * Model CvmFiiInfTrimestralImovelRendaAcabadoContrato
 * CVM FII informe trimestral (imovel renda acabado contrato) from inf_trimestral_fii_imovel_renda_acabado_contrato.csv.
 */
export type CvmFiiInfTrimestralImovelRendaAcabadoContrato = Prisma.CvmFiiInfTrimestralImovelRendaAcabadoContratoModel
/**
 * Model CvmFiiInfTrimestralImovelRendaAcabadoInquilino
 * CVM FII informe trimestral (imovel renda acabado inquilino) from inf_trimestral_fii_imovel_renda_acabado_inquilino.csv.
 */
export type CvmFiiInfTrimestralImovelRendaAcabadoInquilino = Prisma.CvmFiiInfTrimestralImovelRendaAcabadoInquilinoModel
/**
 * Model CvmFiiInfTrimestralRentabilidadeEfetiva
 * CVM FII informe trimestral (rentabilidade efetiva) from inf_trimestral_fii_rentabilidade_efetiva.csv.
 */
export type CvmFiiInfTrimestralRentabilidadeEfetiva = Prisma.CvmFiiInfTrimestralRentabilidadeEfetivaModel
/**
 * Model CvmFiiInfTrimestralResultadoContabilFinanceiro
 * CVM FII informe trimestral (resultado contabil financeiro) from inf_trimestral_fii_resultado_contabil_financeiro.csv.
 */
export type CvmFiiInfTrimestralResultadoContabilFinanceiro = Prisma.CvmFiiInfTrimestralResultadoContabilFinanceiroModel
/**
 * Model CvmFiiInfTrimestralTerreno
 * CVM FII informe trimestral (terreno) from inf_trimestral_fii_terreno.csv.
 */
export type CvmFiiInfTrimestralTerreno = Prisma.CvmFiiInfTrimestralTerrenoModel
/**
 * Model CvmFiiInfAnualAtivoAdquirido
 * CVM FII informe anual (ativo_adquirido) from inf_anual_fii_ativo_adquirido.csv.
 */
export type CvmFiiInfAnualAtivoAdquirido = Prisma.CvmFiiInfAnualAtivoAdquiridoModel
/**
 * Model CvmFiiInfAnualAtivoTransacao
 * CVM FII informe anual (ativo_transacao) from inf_anual_fii_ativo_transacao.csv.
 */
export type CvmFiiInfAnualAtivoTransacao = Prisma.CvmFiiInfAnualAtivoTransacaoModel
/**
 * Model CvmFiiInfAnualAtivoValorContabil
 * CVM FII informe anual (ativo_valor_contabil) from inf_anual_fii_ativo_valor_contabil.csv.
 */
export type CvmFiiInfAnualAtivoValorContabil = Prisma.CvmFiiInfAnualAtivoValorContabilModel
/**
 * Model CvmFiiInfAnualComplemento
 * CVM FII informe anual (complemento) from inf_anual_fii_complemento.csv.
 */
export type CvmFiiInfAnualComplemento = Prisma.CvmFiiInfAnualComplementoModel
/**
 * Model CvmFiiInfAnualDiretorResponsavel
 * CVM FII informe anual (diretor_responsavel) from inf_anual_fii_diretor_responsavel.csv.
 */
export type CvmFiiInfAnualDiretorResponsavel = Prisma.CvmFiiInfAnualDiretorResponsavelModel
/**
 * Model CvmFiiInfAnualDistribuicaoCotistas
 * CVM FII informe anual (distribuicao_cotistas) from inf_anual_fii_distribuicao_cotistas.csv.
 */
export type CvmFiiInfAnualDistribuicaoCotistas = Prisma.CvmFiiInfAnualDistribuicaoCotistasModel
/**
 * Model CvmFiiInfAnualExperienciaProfissional
 * CVM FII informe anual (experiencia_profissional) from inf_anual_fii_experiencia_profissional.csv.
 */
export type CvmFiiInfAnualExperienciaProfissional = Prisma.CvmFiiInfAnualExperienciaProfissionalModel
/**
 * Model CvmFiiInfAnualGeral
 * CVM FII informe anual (geral) from inf_anual_fii_geral.csv.
 */
export type CvmFiiInfAnualGeral = Prisma.CvmFiiInfAnualGeralModel
/**
 * Model CvmFiiInfAnualPrestadorServico
 * CVM FII informe anual (prestador_servico) from inf_anual_fii_prestador_servico.csv.
 */
export type CvmFiiInfAnualPrestadorServico = Prisma.CvmFiiInfAnualPrestadorServicoModel
/**
 * Model CvmFiiInfAnualProcesso
 * CVM FII informe anual (processo) from inf_anual_fii_processo.csv.
 */
export type CvmFiiInfAnualProcesso = Prisma.CvmFiiInfAnualProcessoModel
/**
 * Model CvmFiiInfAnualProcessoSemelhante
 * CVM FII informe anual (processo_semelhante) from inf_anual_fii_processo_semelhante.csv.
 */
export type CvmFiiInfAnualProcessoSemelhante = Prisma.CvmFiiInfAnualProcessoSemelhanteModel
/**
 * Model CvmFiiInfAnualRepresentanteCotista
 * CVM FII informe anual (representante_cotista) from inf_anual_fii_representante_cotista.csv.
 */
export type CvmFiiInfAnualRepresentanteCotista = Prisma.CvmFiiInfAnualRepresentanteCotistaModel
/**
 * Model CvmFiiInfAnualRepresentanteCotistaFundo
 * CVM FII informe anual (representante_cotista_fundo) from inf_anual_fii_representante_cotista_fundo.csv.
 */
export type CvmFiiInfAnualRepresentanteCotistaFundo = Prisma.CvmFiiInfAnualRepresentanteCotistaFundoModel
/**
 * Model CvmFiiDfin
 * CVM FII DFIN (dfin_fii.csv).
 */
export type CvmFiiDfin = Prisma.CvmFiiDfinModel
/**
 * Model CvmFidcInfMensalTabIii
 * CVM dataset for cvm_fidc_inf_mensal_tab_iii.
 * CVM dataset for cvm_fidc_inf_mensal_tab_iii.
 */
export type CvmFidcInfMensalTabIii = Prisma.CvmFidcInfMensalTabIiiModel
/**
 * Model CvmFidcInfMensalTabIi
 * CVM dataset for cvm_fidc_inf_mensal_tab_ii.
 */
export type CvmFidcInfMensalTabIi = Prisma.CvmFidcInfMensalTabIiModel
/**
 * Model CvmFidcInfMensalTabIv
 * CVM dataset for cvm_fidc_inf_mensal_tab_iv.
 */
export type CvmFidcInfMensalTabIv = Prisma.CvmFidcInfMensalTabIvModel
/**
 * Model CvmFidcInfMensalTabIx
 * CVM dataset for cvm_fidc_inf_mensal_tab_ix.
 */
export type CvmFidcInfMensalTabIx = Prisma.CvmFidcInfMensalTabIxModel
/**
 * Model CvmFidcInfMensalTabI
 * CVM dataset for cvm_fidc_inf_mensal_tab_i.
 */
export type CvmFidcInfMensalTabI = Prisma.CvmFidcInfMensalTabIModel
/**
 * Model CvmFidcInfMensalTabVii
 * CVM dataset for cvm_fidc_inf_mensal_tab_vii.
 */
export type CvmFidcInfMensalTabVii = Prisma.CvmFidcInfMensalTabViiModel
/**
 * Model CvmFidcInfMensalTabViii
 * CVM dataset for cvm_fidc_inf_mensal_tab_viii.
 */
export type CvmFidcInfMensalTabViii = Prisma.CvmFidcInfMensalTabViiiModel
/**
 * Model CvmFidcInfMensalTabVi
 * CVM dataset for cvm_fidc_inf_mensal_tab_vi.
 */
export type CvmFidcInfMensalTabVi = Prisma.CvmFidcInfMensalTabViModel
/**
 * Model CvmFidcInfMensalTabV
 * CVM dataset for cvm_fidc_inf_mensal_tab_v.
 */
export type CvmFidcInfMensalTabV = Prisma.CvmFidcInfMensalTabVModel
/**
 * Model CvmFidcInfMensalTabX11
 * CVM dataset for cvm_fidc_inf_mensal_tab_x_1_1.
 */
export type CvmFidcInfMensalTabX11 = Prisma.CvmFidcInfMensalTabX11Model
/**
 * Model CvmFidcInfMensalTabX1
 * CVM dataset for cvm_fidc_inf_mensal_tab_x_1.
 */
export type CvmFidcInfMensalTabX1 = Prisma.CvmFidcInfMensalTabX1Model
/**
 * Model CvmFidcInfMensalTabX
 * CVM dataset for cvm_fidc_inf_mensal_tab_x.
 */
export type CvmFidcInfMensalTabX = Prisma.CvmFidcInfMensalTabXModel
/**
 * Model CvmFidcInfMensalTabX2
 * CVM dataset for cvm_fidc_inf_mensal_tab_x_2.
 */
export type CvmFidcInfMensalTabX2 = Prisma.CvmFidcInfMensalTabX2Model
/**
 * Model CvmFidcInfMensalTabX3
 * CVM dataset for cvm_fidc_inf_mensal_tab_x_3.
 */
export type CvmFidcInfMensalTabX3 = Prisma.CvmFidcInfMensalTabX3Model
/**
 * Model CvmFidcInfMensalTabX4
 * CVM dataset for cvm_fidc_inf_mensal_tab_x_4.
 */
export type CvmFidcInfMensalTabX4 = Prisma.CvmFidcInfMensalTabX4Model
/**
 * Model CvmFidcInfMensalTabX5
 * CVM dataset for cvm_fidc_inf_mensal_tab_x_5.
 */
export type CvmFidcInfMensalTabX5 = Prisma.CvmFidcInfMensalTabX5Model
/**
 * Model CvmFidcInfMensalTabX6
 * CVM dataset for cvm_fidc_inf_mensal_tab_x_6.
 */
export type CvmFidcInfMensalTabX6 = Prisma.CvmFidcInfMensalTabX6Model
/**
 * Model CvmFidcInfMensalTabX7
 * CVM dataset for cvm_fidc_inf_mensal_tab_x_7.
 */
export type CvmFidcInfMensalTabX7 = Prisma.CvmFidcInfMensalTabX7Model
/**
 * Model CvmFiagroInfMensalGeral
 * CVM dataset for cvm_fiagro_inf_mensal_geral.
 */
export type CvmFiagroInfMensalGeral = Prisma.CvmFiagroInfMensalGeralModel
/**
 * Model CvmFiagroInfMensalSubclasse
 * CVM dataset for cvm_fiagro_inf_mensal_subclasse.
 */
export type CvmFiagroInfMensalSubclasse = Prisma.CvmFiagroInfMensalSubclasseModel
/**
 * Model CvmFipInfQuadrimestral
 * CVM dataset for cvm_fip_inf_quadrimestral.
 */
export type CvmFipInfQuadrimestral = Prisma.CvmFipInfQuadrimestralModel
/**
 * Model CvmFieMedidasMes
 * CVM dataset for cvm_fie_medidas_mes.
 */
export type CvmFieMedidasMes = Prisma.CvmFieMedidasMesModel
/**
 * Model Report
 * Fnet/CVM report metadata for instruments. Populated by report ingestion pipelines.
 */
export type Report = Prisma.ReportModel
/**
 * Model Summary
 * LLM/summary output linked to a report. Populated by summary pipelines.
 */
export type Summary = Prisma.SummaryModel
/**
 * Model SummaryFII
 * FII-specific summary fields linked to Summary. Populated by summary pipelines.
 */
export type SummaryFII = Prisma.SummaryFIIModel
/**
 * Model PriceHistory
 * Daily price history per instrument. Source: B3/COTAHIST or other providers.
 */
export type PriceHistory = Prisma.PriceHistoryModel
/**
 * Model PriceHistoryAdjusted
 * Daily price history adjusted by stock split/reverse split events.
 * Computed by market-data derived processor.
 */
export type PriceHistoryAdjusted = Prisma.PriceHistoryAdjustedModel
/**
 * Model MarketSeries
 * Public macro/FX benchmark series (e.g., BCB SGS/PTAX).
 */
export type MarketSeries = Prisma.MarketSeriesModel
/**
 * Model VpSnapshot
 * Monthly PL/VP snapshot per instrument (e.g., CVM inf_mensal_fii).
 */
export type VpSnapshot = Prisma.VpSnapshotModel
/**
 * Model LiquiditySnapshot
 * Number of investors (cotistas) snapshot per instrument and competence.
 */
export type LiquiditySnapshot = Prisma.LiquiditySnapshotModel
/**
 * Model ScreenerSnapshot
 * Derived snapshot with screening metrics used by advanced catalog filters.
 */
export type ScreenerSnapshot = Prisma.ScreenerSnapshotModel
/**
 * Model ScreenerSnapshotPosition
 * Materialized positions per screener snapshot used by portfolio/top-N views.
 */
export type ScreenerSnapshotPosition = Prisma.ScreenerSnapshotPositionModel
/**
 * Model ScreenerSnapshotRelated
 * Top related instruments per screener snapshot used by compare suggestions.
 */
export type ScreenerSnapshotRelated = Prisma.ScreenerSnapshotRelatedModel
/**
 * Model AssetExposureDimension
 * Configurable canonical dimension used to aggregate asset and portfolio exposures.
 */
export type AssetExposureDimension = Prisma.AssetExposureDimensionModel
/**
 * Model AssetExposureValue
 * Canonical value within a configurable exposure dimension.
 */
export type AssetExposureValue = Prisma.AssetExposureValueModel
/**
 * Model AssetExposureProfile
 * Current materialized coverage and source metadata for one instrument/dimension pair.
 */
export type AssetExposureProfile = Prisma.AssetExposureProfileModel
/**
 * Model AssetExposureProfileItem
 * Canonical source item (for example a property) behind one current asset exposure.
 */
export type AssetExposureProfileItem = Prisma.AssetExposureProfileItemModel
/**
 * Model AssetExposureProfileValue
 * Weighted canonical exposure value materialized for a instrument profile.
 */
export type AssetExposureProfileValue = Prisma.AssetExposureProfileValueModel
/**
 * Model Dividend
 * Dividend events (com/pay dates) per instrument. Source: inf_rendimento_fii, FRE, Fnet, etc.
 */
export type Dividend = Prisma.DividendModel
/**
 * Model DividendEventSnapshot
 * Derived dividend-event snapshot with split-adjusted per-share values.
 */
export type DividendEventSnapshot = Prisma.DividendEventSnapshotModel
/**
 * Model CorporateAction
 * Corporate actions from market providers (Fnet/B3): cash dividends, stock dividends, subscriptions.
 */
export type CorporateAction = Prisma.CorporateActionModel
/**
 * Model InstrumentSyncState
 * Sync control per instrument for derived datasets (prices/vp/dividends).
 */
export type InstrumentSyncState = Prisma.InstrumentSyncStateModel
/**
 * Model MarketDataUrlState
 * Market data URL state for processors (etag/last_modified, last processed).
 */
export type MarketDataUrlState = Prisma.MarketDataUrlStateModel
/**
 * Model PipelineRun
 * 
 */
export type PipelineRun = Prisma.PipelineRunModel
/**
 * Model PipelineStepRun
 * 
 */
export type PipelineStepRun = Prisma.PipelineStepRunModel
/**
 * Model EmailPreference
 * Email notification preference for a user. Created on demand, never at signup.
 */
export type EmailPreference = Prisma.EmailPreferenceModel
/**
 * Model EmailProcessingStatus
 * Processing bookmark for one email preference, tracked by the Python pipeline.
 */
export type EmailProcessingStatus = Prisma.EmailProcessingStatusModel
/**
 * Model EmailCampaign
 * Email campaign (promotional or transactional). Created via admin UI.
 */
export type EmailCampaign = Prisma.EmailCampaignModel
/**
 * Model EmailCampaignStatus
 * Per-preference delivery status for a campaign.
 */
export type EmailCampaignStatus = Prisma.EmailCampaignStatusModel
/**
 * Model DmarcImporterState
 * Singleton: worker state so the IMAP ingestor knows where it left off.
 */
export type DmarcImporterState = Prisma.DmarcImporterStateModel
/**
 * Model DmarcAggregateReport
 * One row per aggregate DMARC report (a ZIP/XML delivered via email).
 */
export type DmarcAggregateReport = Prisma.DmarcAggregateReportModel
/**
 * Model DmarcAggregateRecord
 * One row per (report × source IP) inside an aggregate report.
 */
export type DmarcAggregateRecord = Prisma.DmarcAggregateRecordModel
/**
 * Model DmarcForensicReport
 * Forensic (failure) DMARC report – rare, always a red flag.
 */
export type DmarcForensicReport = Prisma.DmarcForensicReportModel
/**
 * Model TlsRptReport
 * TLS-RPT report – optional, included for future use.
 */
export type TlsRptReport = Prisma.TlsRptReportModel
/**
 * Model FblReport
 * Feedback Loop report – someone marked our email as spam.
 */
export type FblReport = Prisma.FblReportModel
/**
 * Model McpOAuthClient
 * OAuth client registered by a third-party MCP host (dynamic client
 * registration, RFC 7591). Public clients only: PKCE is mandatory and no
 * client secret is issued.
 */
export type McpOAuthClient = Prisma.McpOAuthClientModel
/**
 * Model McpGrant
 * User consent for one MCP client. Revoking the grant immediately
 * invalidates the tokens issued under it.
 */
export type McpGrant = Prisma.McpGrantModel
/**
 * Model McpAuthCode
 * Single-use authorization code bound to a PKCE S256 challenge.
 * Short-lived; consumed on exchange and trimmed by the retention job.
 */
export type McpAuthCode = Prisma.McpAuthCodeModel
/**
 * Model McpRefreshToken
 * Opaque MCP refresh token, stored hashed and rotated on every use.
 * Presenting a consumed token revokes the whole grant (reuse detection).
 */
export type McpRefreshToken = Prisma.McpRefreshTokenModel
/**
 * Model McpUsageLog
 * Audit trail of MCP tool calls. Trimmed by the daily retention job.
 */
export type McpUsageLog = Prisma.McpUsageLogModel
